module.exports = __webpack_public_path__ + "static/media/naturalShine.23249edf.gif";